import {XauditModel} from '../../../xaudit.model';

export class EndoMultiToothExamAutoFillConfigurationModel extends XauditModel {
  AutoFillID: string;
  AutofillName: string;
  AutofillOrder: number;
  isVital: boolean;
  enumMTEChiefComplaintID: string = '';
  enumMTEPalpationID: string = '';
  enumMTEPercussionID: string = '';
  enumMTEMobilityID: string = '';
  enumMTEChewingID: string = '';
  enumMTEBiteID: string = '';
  enumMTEAirID: string = '';
  enumMTEColdID: string = '';
  enumMTEHotID: string = '';
  enumMTEeptID: string = '';
  enumMTESinusTrackID: string = '';
  enumMTEOccusalTraumaID: string = '';
  enumMTEFractureID: string = '';
  enumMTEPulpDiagID: string = '';
  enumMTEPerDiagID: string = '';
  enumMTEEndoPrognosisID: string = '';
  enumMTEPerioPrognosisID: string = '';
  enumMTERestorPrognosisID: string = '';
  enumMTERecomendedTxID: string = '';
  enumMTERecomendedTx_AfterID: string = '';
  enumMTERecomendedTx_ThirdID: string = '';
  enumMTETretmentOrderID: string = '';
  enumMTENumberOfVisitsID: string = '';
  enumMTEVitalTestCavityID: string = '';
  enumMTESweetsID: string = '';
  enumMTEFlossingID: string = '';
  enumMTELayingDownID: string = '';
  enumMTEExersiseBPID: string = '';
  enumMTEHeadPosistionID: string = '';
  enumMTECervicalSensID: string = '';
  enumMTEBLateralForceID: string = '';
  enumMTELLateralForceID: string = '';
}
